export class Roles {
    static admin = 'admin';
    static user = 'clerk';
}
